import { API_BASE_URL, DEV } from '@config'
import { api as agoraApi } from './auto-generated/agora'
import { api as eventApi } from './auto-generated/event'
import { createSocket } from './ws'
import { refreshTokenIfExpired } from '@features/auth/utils/refresh-token-if-expired'

agoraApi.enhanceEndpoints({
  endpoints: {
    agoraCreateNewRoom: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(
            eventApi.util.updateQueryData('eventGetEventById', args, (draftEvent) => {
              draftEvent.current_room_id = data.room_id
            }),
          )
          dispatch(
            eventApi.util.updateQueryData('eventGetCurrentEvent', undefined, (draftEvent) => {
              draftEvent.current_room_id = data.room_id
            }),
          )
        } catch {}
      },
    },
    agoraGetRtcRooms: {
      async onCacheEntryAdded(
        arg,
        { updateCachedData, cacheDataLoaded, cacheEntryRemoved, getState },
      ) {
        const { tokens } = (getState() as RootState).auth
        const { eventId } = arg
        let ws
        if (tokens && eventId) {
          try {
            await cacheDataLoaded
            const listener = (event: MessageEvent) => {
              const data = JSON.parse(event.data)
              // if (DEV) console.log(data)
              updateCachedData((draftRtcRooms) => {
                switch (data.event_type) {
                  case 'AGORA_CREATE_NEW_ROOM':
                    draftRtcRooms.push(data.event_message)
                    break
                  default:
                    break
                }
              })
            }
            ws = await createSocket(eventId, listener)
          } catch {}
          await cacheEntryRemoved
          if (ws) {
            ws.close()
          }
        }
      },
    },
  },
})

export { agoraApi }

export * from './auto-generated/agora'
